// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"1dfcb638","401":"dadbec89"}[chunkId] + ".chunk.css";
};